import { Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';

import Menu from '../components/Menu';
import { useConnectOutcome } from '../hooks/useConnectOutcome';

const { Header, Content } = Layout;

const AppLayout = () => {
  const location = useLocation();
  // Hosted here, not in ConnectSorareButton: on mobile that button lives inside the nav
  // Drawer's `extra`, which antd does not mount while the drawer is closed.
  const connectOutcomeHolder = useConnectOutcome();

  return (
    <Layout data-testid="sa-app-layout">
      {connectOutcomeHolder}
      <Header data-testid="sa-app-header">
        <Menu location={location} />
      </Header>
      <Content data-testid="sa-app-content">
        <Outlet />
      </Content>
    </Layout>
  );
};

export default AppLayout;
